import * as THREE from 'three';
import Experience from '../Experience.js';

export default class AudioManager {
    constructor() {
        this.experience = Experience.getInstance();
        this.camera = this.experience.camera.instance;
        this.debug = this.experience.debug;

        this.init();
        this.addEventListeners();
        this.playBackgroundAudio();
        // this.addStats();
    }

    init() {
        // create an AudioListener and add it to the camera
        const listener = new THREE.AudioListener();
        this.camera.add(listener);

        this.backgroundMusic = new THREE.Audio(listener);
        this.effectSound = new THREE.Audio(listener);
        this.finalEffectSound = new THREE.Audio(listener);
        this.audioLoader = new THREE.AudioLoader();

        this.bgMusicOn = false;
        this.soundsOn = false;
    }

    playBackgroundAudio() {
        this.audioLoader.load('/audios/daisy_girl.mp3', (buffer) => {
            this.backgroundMusic.setBuffer(buffer);
            this.backgroundMusic.setLoop(true);
            this.backgroundMusic.setVolume(0.1);
            // this.backgroundMusic.play();
        });
    }

    addEventListeners() {
        const music = document.getElementById("toggle-music");
        music.addEventListener("click", () => {
            if (this.bgMusicOn) {
                this.bgMusicOn = false;
                music.textContent = "🔇 Music";
                this.backgroundMusic.pause();
            }
            else {
                this.bgMusicOn = true;
                music.textContent = "🔊 Music";
                this.backgroundMusic.play();
            }
        });

        const sounds = document.getElementById("toggle-audio");
        sounds.addEventListener("click", () => {
            if (this.soundsOn) {
                this.soundsOn = false;
                sounds.textContent = "🔕 Sounds";
            }
            else {
                this.soundsOn = true;
                sounds.textContent = "🔔 Sounds";
            }
        });
    }

    addStats() {
        if (this.debug.active) {
            this.debug.ui.add({ musicEnabled: true }, 'musicEnabled').name('Bg Music').onChange((value) => {
                if (value) {
                    this.backgroundMusic.play();
                } else {
                    this.backgroundMusic.pause();
                }
            });
        }
    }

    playAudio(audio) {
        if (!this.soundsOn) return;

        this.audioLoader.load(audio, (buffer) => {
            this.effectSound.setBuffer(buffer);
            this.effectSound.setVolume(1.0);

            if (this.effectSound.isPlaying)
                this.effectSound.stop();
            this.effectSound.play();
        });
    }
    playFinalAudio(audio) {
        if (!this.soundsOn) return;

        this.audioLoader.load(audio, (buffer) => {
            this.finalEffectSound.setBuffer(buffer);
            this.finalEffectSound.setVolume(1.0);

            if (this.finalEffectSound.isPlaying)
                this.finalEffectSound.stop();
            this.finalEffectSound.play();
        });
    }
}